"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    NotificationManager: function() {
        return _notificationManager.default;
    },
    notifySuccess: function() {
        return notifySuccess;
    },
    notifyError: function() {
        return notifyError;
    }
});
var _notificationManager = /*#__PURE__*/ _interopRequireDefault(require("./NotificationManager"));
var _types = _exportStar(require("./types"), exports);
_exportStar(require("./NotificationContainer"), exports);
_exportStar(require("./Notification"), exports);
function _exportStar(from, to) {
    Object.keys(from).forEach(function(k) {
        if (k !== "default" && !Object.prototype.hasOwnProperty.call(to, k)) Object.defineProperty(to, k, {
            enumerable: true,
            get: function() {
                return from[k];
            }
        });
    });
    return from;
}
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var notifySuccess = function(param) {
    var title = param.title, text = param.text;
    _notificationManager.default.create({
        type: "success",
        layout: _types.NotificationLayout.SIMPLE,
        title: title,
        text: text
    });
};
var notifyError = function(param) {
    var title = param.title, error = param.error, text = param.text;
    console.error("Notify error", error);
    _notificationManager.default.create({
        type: "error",
        layout: _types.NotificationLayout.SIMPLE,
        title: title || "Something failed",
        text: text || ""
    });
};

//# sourceMappingURL=index.js.map